import { useMatches, type UIMatch } from "react-router-dom"

/** Static metadata attached to routes via `handle`. */
export interface RouteHandle {
  /** Page name used for the document title. */
  title?: string
  /** Breadcrumb label; omit to hide the route from breadcrumbs. */
  crumb?: string
  /**
   * Hide the phone bottom tab bar (create/edit screens): the form's own sticky
   * action bar owns the bottom edge there.
   */
  hideMobileNav?: boolean
}

export type RouteMatch = UIMatch<unknown, RouteHandle | undefined>

export function useRouteMatches() {
  return useMatches() as RouteMatch[]
}
